import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import generateCorsAnywhereUrl from 'utils/generateCorsAnywhereUrl'
import View from './View'
import './styles.css'

class QuotePicker extends React.Component {
  defaultQuote = {
    author: null,
    quote: null,
    tags: [],
  }

  state = {
    data: {},
    loading: true,
    error: null,
    mostRecentRequest: null,
  }

  componentDidMount = () => {
    const { onChange, value } = this.props

    if (typeof value === 'object') {
      if (typeof value.toJS === 'function') {
        onChange(value.toJS())
      } else {
        if (value.author || value.quote || Array.isArray(value.tags)) {
          onChange(value)
        } else {
          onChange(this.defaultQuote)
        }
      }
    } else {
      onChange(this.defaultQuote)
    }
    return this.getQuotes()
  }

  componentDidUpdate = () => console.log(this.props.value)

  getQuotes = ({ url } = {}) => {
    const requestUrl =
      url ||
      'https://api.paperquotes.com/apiv1/quotes/?limit=500&tags=inspiration,inspirational,motivational,motivation'
    const token = 'e2eeb1aa9f32eb07fa04595a0c457ecb6fadb772'
    axios({
      url: generateCorsAnywhereUrl(requestUrl),
      headers: {
        Authorization: `Token ${token}`,
      },
    })
      .then(({ data }) =>
        this.setState({ data, mostRecentRequest: requestUrl, loading: false }),
      )
      .catch((error) => {
        console.error(error)
        return this.setState({
          error,
          mostRecentRequest: requestUrl,
          loading: false,
        })
      })
  }

  selectQuote = (newQuote, closeModal) => () => {
    const { onChange, value: currentQuote } = this.props
    const { author, quote, tags } = newQuote
    if (currentQuote && quote == currentQuote.quote) {
      console.error('You are using that quote already at the moment.')
      return false
    }

    onChange({
      author: author || '',
      quote,
      tags: tags || ['inspirational', 'inspiration'],
    })
    return closeModal()
  }

  fetchNext = () => {
    const { state } = this
    const url = state.data.next
    return this.getQuotes({ url })
  }

  fetchPrevious = () => {
    const { state } = this
    const url = state.data.previous
    return this.getQuotes({ url })
  }

  quoteRef = (e) => {
    // currently unused
    this.quoteElem = e
  }

  authorRef = (e) => {
    // currently unused
    this.authorElem = e
  }

  tagsRef = (e) => {
    // currently unused
    this.tagsElem = e
  }

  render() {
    const value =
      this.props.value !== undefined ? this.props.value : this.defaultQuote

    return (
      <View
        {...this.state}
        {...this.props}
        value={value}
        selectQuote={this.selectQuote}
        fetchPrevious={this.fetchPrevious}
        fetchNext={this.fetchNext}
        quoteRef={this.quoteRef}
        authorRef={this.authorRef}
        tagsRef={this.tagsRef}
      />
    )
  }
}

QuotePicker.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
}

export default QuotePicker



// WEBPACK FOOTER //
// ./src/cms/widgets/QuotePicker/index.js